import {Icon} from 'antd'

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1382691_vm9crekhxpr.js',
});
IconFont.pre = 'wx'
export default IconFont